import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts'; // Import ApexCharts
import { DatePicker, Select } from 'antd'; 
import { getProductChartDataReducer } from '../store/report';
import { useDispatch, useSelector } from 'react-redux';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ProductChart = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [period, setPeriod] = useState('weekly'); // Default to weekly
  const dispatch = useDispatch();
  const { productChartData } = useSelector((state) => state.report);
  useEffect(() => {
    // Filter data based on selected dates and period
    dispatch(getProductChartDataReducer({
      startDate: startDate,
      endDate: endDate,
      period: period,
    }))
  }, [startDate, endDate, period, dispatch]);

  const chartData = {
    series: [{
      name: 'Total Quantity',
      data: productChartData?.map(item => item.totalQuantity),
    }],
    options: {
      chart: {
        type: 'line',
        height: 350,
      },
      xaxis: {
        categories: productChartData?.map(item => item.productName),
      },
      title: {
        text: 'Product Quantity Over Time',
        align: 'left',
      },
      stroke: {
        curve: 'smooth',
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
    },
  };

  return (
    <div>
      <RangePicker
        onChange={(dates) => {
          setStartDate(dates[0]);
          setEndDate(dates[1]);
        }}
      />
      <Select defaultValue="weekly" onChange={setPeriod} style={{ width: 120, marginLeft: 10 }}>
        <Option value="daily">Daily</Option>
        <Option value="weekly">Weekly</Option>
        <Option value="monthly">Monthly</Option>
      </Select>
      <Chart options={chartData.options} series={chartData.series} type="line" height={350} />
    </div>
  );
};

export default ProductChart; 